import React, { useMemo } from "react"
import styled from "styled-components"

import STYLE_CONSTANTS from "~/style/constants"

const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-bottom: 1rem;
`

const TextContainer = styled.div`
  width: 100%;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  margin-left: 1.8rem;
  margin-top: 0.7rem;
  text-align: center;
`

const Title = styled.div`
  color: ${props => props.theme.colors.primary};
  font-size: 1rem;
  transition: all 0.5s ease;
`

const Description = styled.div`
  margin-top: 0.625rem;
  color: ${STYLE_CONSTANTS.colors.text.buttonGray};
  font-size: 0.875rem;
`

const StatusInformation = ({ itemName, duration }) => {
  const name = useMemo(() => `We are searching for your ${itemName}`, [itemName])

  const description = useMemo(() => {
    if (isNaN(duration)) return "Please be patient as your search may take some time to complete."

    const durationSeconds = duration / 1000
    let displayUnits = "seconds"
    let displayDuration = durationSeconds

    if (durationSeconds > 60) {
      displayUnits = "minutes"
      const durationMinutes = Math.floor(durationSeconds / 60)
      if (durationMinutes === 1) displayUnits = "minute"
      displayDuration = durationMinutes
    }

    return `Please be patient as your search may take up to ${displayDuration} ${displayUnits} to complete.`
  }, [duration])

  return (
    <ItemContainer>
      <TextContainer>
        <Title>{name}</Title>
        <Description>{description}</Description>
      </TextContainer>
    </ItemContainer>
  )
}

export default StatusInformation
